import { render, staticRenderFns } from "./TTTQMTemplate.vue?vue&type=template&id=110b64d2&scoped=true"
import script from "./TTTQMTemplate.vue?vue&type=script&lang=js"
export * from "./TTTQMTemplate.vue?vue&type=script&lang=js"
import style0 from "./TTTQMTemplate.vue?vue&type=style&index=0&id=110b64d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110b64d2",
  null
  
)

export default component.exports